import React, { Fragment } from "react";
import AppBar from 'material-ui/AppBar';
import Toolbar from 'material-ui/Toolbar';
import Button from 'material-ui/Button';
import { Link } from "react-router-dom";

import Logo from './../images/logo.svg';


export default (props) =>{
    return (
        <div style={{ flexGrow: 1 }}>
        <AppBar position="static">
            <Toolbar style={{backgroundColor:'#333333'}}>

                <div style={{ position:'relative', top:'-2px', marginRight:'40px'}}>
                    <Link to="/"><img style={{width:'131px'}} src={Logo} alt='Venkman' /></Link>
                    <div style={{position:'absolute', fontWeight:100, fontSize:'11px', left:'27px', bottom:'-10px'}}>web experiments</div>
                </div>
                
                <div style={{flex:1}}>
                    <Link to="/tips"><Button color="inherit" className="hideSmall">DOCS</Button></Link>
                    {!!props.user &&
                        <Link to="/experiments"><Button color="inherit">EXPERIMENTS</Button></Link>
                    }
                    {!!props.user && props.user.isResearcher &&
                        <Link to="/manage-experiments"><Button color="inherit">MY EXPERIMENTS</Button></Link>
                    }
                </div>

                {!!props.user && 
                    <Fragment>
                        <Link to="/my-profile"><Button color="inherit">MY PROFILE</Button></Link>
                        <Link to="/logout"><Button color="inherit">LOG OUT</Button></Link>
                    </Fragment>
                }

                 {!props.user && 
                    <Fragment>
                        <Link to="/login"><Button color="inherit">LOGIN</Button></Link>
                    </Fragment>
                }

            </Toolbar>
        </AppBar>
        </div>
    );
}


// WEBPACK FOOTER //
// ./src/components/Nav.js